<template>
  <div>
    <img :src="src" alt="img" class="topImgMobile">
  </div>
</template>

<script>
export default {
  name: 'wmt-topBg',
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="less" scoped>
.topImg {
  width: 100%;
  // height: 540px;
  object-fit: fill;
}
.topImgMobile {
  width: 100%;
  // height: 140px;
  object-fit: fill;
}
</style>